// AI Generated Test
import { Component, Input } from '@angular/core';

@Component({
    selector: 'seo-information-missing-h1',
    standalone: false,
    template: `
        <h5 translate>There is no H1 on this page</h5>
    `,
})
export class SeoInformationMissingH1Component {
    @Input() seo: any;
}
